import React from 'react';
import classes from './index.module.scss';

const Logo = ({ children, path }) => {
  return (
    <a 
      href={path}
      className={classes.Logo}
      tabIndex={-1}
    >
      {children}
    </a>
  )
}

export default Logo;